import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { PageHeader, Loading, ErrorState, EmptyState } from "@/components/States";
import QuizResult from "@/components/QuizResult";
import { api, formatError } from "@/lib/api";

export function HistoryList() {
  const nav = useNavigate();
  const [items, setItems] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get("/quiz/attempts").then((r) => setItems(r.data)).catch((e) => setErr(formatError(e))); }, []);
  if (err) return <ErrorState message={err} />;
  if (!items) return <Loading />;
  return (
    <div>
      <PageHeader eyebrow="Quiz history" title="Your attempts" text="Every quiz you complete is saved to your account." />
      {items.length === 0 ? <EmptyState testId="history-empty" title="No attempts yet" action="Start a quiz" onAction={() => nav("/quiz")} /> : (
        <div data-testid="history-list" className="overflow-hidden rounded-2xl border border-line bg-surface">
          {items.map((a) => (
            <Link key={a.id} to={`/history/${a.id}`} data-testid={`history-item-${a.id}`} className="flex items-center gap-4 border-b border-line px-5 py-4 text-sm last:border-0 hover:bg-canvas-2">
              <div className="flex-1">
                <p className="font-semibold text-ink">{a.subject_name} {a.is_daily && <span className="ml-2 rounded-full bg-aqua-soft px-2 py-0.5 text-[10px] font-semibold uppercase text-aqua">Daily</span>}</p>
                <p className="text-xs text-ink-3">{a.topic} · <span className="capitalize">{a.difficulty}</span> · {new Date(a.created_at).toLocaleString()}</p>
              </div>
              <span className="font-mono font-semibold">{a.score}/{a.total}</span>
              <span className={`w-14 text-right font-mono text-xs ${a.percentage >= 60 ? "text-emerald-600" : "text-amber-600"}`}>{a.percentage}%</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}

export function AttemptDetail() {
  const { id } = useParams();
  const [a, setA] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get(`/quiz/attempts/${id}`).then((r) => setA(r.data)).catch((e) => setErr(formatError(e))); }, [id]);
  if (err) return <ErrorState message={err} />;
  if (!a) return <Loading />;
  return (
    <div>
      <Link to="/history" data-testid="attempt-back-link" className="mb-6 inline-flex items-center gap-2 text-sm text-ink-3 hover:text-ink"><ArrowLeft className="h-4 w-4" />All attempts</Link>
      <QuizResult attempt={a} />
    </div>
  );
}
